import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import SectionContainer from "../../../components/sectionContainer/sectionContainer";
import { actionCreators } from "./redux/sagas/firstRiders/firstRiders";
import { isModuleActive } from "../../../utils/modules";
import { configuratorStore } from "../dashboardConfigurator/dashboard";
import { configuratorMonthSwitcherStore } from "../monthSwitcherModule/monthSwitcher";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import FirstTimeRidesMonthToDate from "./smartComponents/firstTimeRidesMonthToDate";
import FirstTimeRidesMonthToDateChange from "./smartComponents/firstTimeRidesMonthToDateChange";
import PreviousFirstTimeRidesMonthToDate from "./smartComponents/prevFirstTimeRidesMonthToDate";

import ClosingMonthToDate from "./smartComponents/closingMonthToDate";
import ClosingPercentMonthToDate from "./smartComponents/closingPercentMonthToDate";
import ClosingPercentMonthToDateChange from "./smartComponents/closingPercentMonthToDateChange";

import PreviousClosingMonthToDate from "./smartComponents/prevClosingMonthToDate";
import PreviousClosingPercentMonthToDate from "./smartComponents/prevClosingPercentMonthToDate";

import ClosingPieChart from "./smartComponents/closingPieChart";
import LearnMore from "../../../components/learnMore/learnMore";

export class FirstRidersModule extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      initRequest: false,
      moduleHeight: 650
    };
  }

  componentDidMount() {
    if (isModuleActive(this.props.currentUser.dashboardPreferences, "First Time Riders")) {
      this.props.fetchCurrentUser({ user: this.props.currentUser });
      this.setState({
        initRequest: true
      });
    }

    // Dashboard configurator store
    configuratorStore.subscribe(() => {
      const state = configuratorStore.getState();
      if (
        isModuleActive(state.dashboardConfigurator.preferences, "First Time Riders") &&
        !this.state.initRequest
      ) {
        const { monthSwitcher } = configuratorMonthSwitcherStore.getState();

        this.props.fetchCurrentUser({ user: this.props.currentUser, date: monthSwitcher.date });
        this.setState({ initRequest: true });
      }
    });

    // Month switcher store
    let previousDate;
    configuratorMonthSwitcherStore.subscribe(() => {
      if (this.state.initRequest) {
        const currentDate = configuratorMonthSwitcherStore.getState().monthSwitcher.date;

        if (currentDate !== previousDate) {
          previousDate = currentDate;
          this.props.updateAllData(currentDate);
        }
      }
    });
  }

  checkForZeroes = () => {
    let show = false;

    if (this.props.closingBreakdown?.length !== 0) {
      show = true;
    }

    return show;
  };

  render() {
    const { learnMoreId, title, content } = this.props.learnMore;
    return (
      <SectionToggle
        title={this.props.currentUser.moduleName}
        learnMore={<LearnMore learnMoreId={learnMoreId} title={title} content={content} html />}
        customClass={`firstridersWidget ${this.props.isLoading ? "" : "active"}`}
        height={this.state.moduleHeight}
        isLoading={this.props.isLoading}
        content={
          <div>
            <div className="section-group">
              <span className="width-50">
                <SectionContainer title="Month To Date">
                  <FirstTimeRidesMonthToDate />
                  <FirstTimeRidesMonthToDateChange />
                </SectionContainer>
              </span>
              <span className="width-50">
                <SectionContainer title="Previous Month To Date">
                  <PreviousFirstTimeRidesMonthToDate />
                </SectionContainer>
              </span>
            </div>
            <div className="section-group">
              <span className="width-50 bottom" style={{ paddingBottom: "50px" }}>
                <SectionContainer title="Conversion % Month To Date">
                  <ClosingPercentMonthToDate />
                  <ClosingPercentMonthToDateChange />
                </SectionContainer>
              </span>
              <span className="width-50 bottom" style={{ paddingBottom: "50px" }}>
                <SectionContainer title="Previous Month Conversion % MTD">
                  <PreviousClosingPercentMonthToDate />
                </SectionContainer>
              </span>
            </div>
            <div className="section-group">
              <span className="width-50">
                <SectionContainer title="Total Purchases Month to Date"></SectionContainer>
                <ClosingMonthToDate />
              </span>
              <span className="width-50">
                <SectionContainer title="Previous Month Purchase MTD">
                  <PreviousClosingMonthToDate />
                </SectionContainer>
              </span>
            </div>
            <div className="section-group" style={{ height: "350px" }}>
              <SectionContainer title="Purchases Breakdown" customStyles="pie-chart">
                {this.checkForZeroes() ? (
                  <ClosingPieChart />
                ) : (
                  <p style={styles.noData}>No data found for this time period.</p>
                )}
              </SectionContainer>
            </div>
          </div>
        }
      />
    );
  }
}

const styles = {
  noData: {
    textAlign: "center",
    color: "#8791a0",
    fontSize: "1.5em",
    fontWeight: 300,
    paddingTop: "75px"
  },
  leftBracket: {
    color: "rgb(142, 191, 251)",
    fontSize: "35px",
    padding: "0px 8px",
    fontWeight: "100",
    position: "relative",
    left: "10px"
  },
  rightBracket: {
    color: "rgb(142, 191, 251)",
    fontSize: "35px",
    padding: "0px 8px",
    fontWeight: "100",
    position: "relative",
    right: "10px"
  }
};

export default connect(
  (state) => ({
    isLoading: state.firstRiders.isLoading,
    userParams: state.firstRiders.currentUser,
    closingBreakdown: state.firstRiders.firstTimeRiders.closingBreakdown
    // followUps: state.leadsManagement.followUps,
    // nearlyExhausted: state.leadsManagement.nearlyExhausted
  }),
  {
    fetchCurrentUser: actionCreators.fetchCurrentUser,
    updateAllData: actionCreators.updateAllData
  }
)(FirstRidersModule);

FirstRidersModule.propTypes = {
  fetchCurrentUser: PropTypes.func.isRequired,
  updateAllData: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  currentUser: PropTypes.object,
  closingBreakdown: PropTypes.array,
  learnMore: PropTypes.objectOf(PropTypes.string)
};
